export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const truncateString = (str: string, width: number) => {
  return str.length > width ? `${str.substring(0, width).trim()}...` : str
}

export const stripHtmlTags = (html: string): string => {
  if (!html) return ''

  // Remove HTML tags
  const withoutTags = html.replace(/<[^>]*>/g, '')

  // Decode common HTML entities
  const decoded = withoutTags
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/g, "'")

  // Normalize whitespace: replace multiple spaces/newlines with single space
  const normalized = decoded.replace(/\s+/g, ' ').trim()

  return normalized
}
